module.exports = ".mt-64 {\n  margin-top: 64px; }\n\n.p-32 {\n  padding: 32px 0 32px 0; }\n\n.mt-24 {\n  margin-top: 24px; }\n\n.ml-32 {\n  margin-left: 32px; }\n\n.bt-primary-empty {\n  text-decoration: none;\n  padding: 1px 21px 1px 21px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/contratos/admin-contratos-novo/form-vinculo/form-vinculo.component.scss
// module id = ./src/app/components/admin/contratos/admin-contratos-novo/form-vinculo/form-vinculo.component.scss
// module chunks = main